module.exports = __webpack_public_path__ + "img/Audience.90256b01.svg";